angular
  .module('fca-used')
  .factory('scroll', scrollService);

scrollService.$inject = ['$window', 'CONFIG'];

function scrollService($window, CONFIG) {
  return {
    to: to,
    top: top
  };

  function top() {
    $window.scroll({
      top: 0,
      behavior: 'smooth'
    });
  }

  function to(selector) {
    var target;
    if (angular.isString(selector)) {
      target = $window.document.querySelector(selector);
    } else {
      target = selector;
    }
    if (target) {
      var offSet = target.getBoundingClientRect().top + $window.pageYOffset;
      var header = $window.document.querySelector(CONFIG.brand.headerSelector);
      if (header) {
        var headerRect = $window.document.querySelector(CONFIG.brand.headerSelector).getBoundingClientRect();
        var headerOffSet = headerRect.height + headerRect.top;
        offSet -= headerOffSet;
      }
      $window.scroll({
        top: offSet,
        behavior: 'smooth'
      });
    }
  }
}
